import React, { FC, ReactNode } from 'react';
import MuiTableCell from '@mui/material/TableCell';
import MuiTableRow from '@mui/material/TableRow';
import { TableColumnType, TableRowType, SelectRowType, SumColumnsType, RowActionPropsType } from 'src/types/table';
import { styled } from '@mui/material/styles';
import translate from '@translate';
import sumArray from 'src/utils/sumArray';
import { formatNumber, isNumericValue } from 'src/utils/formatNumber';
import { colors } from 'src/themes/default';

const MuiTableRowTotal = styled(MuiTableRow)(({ theme }) => ({
    backgroundColor: `${colors.background_B0} !important`,

    '&:hover': {
        backgroundColor: `${colors.background_B0} !important`,
    },

    '& > td': {
        padding: '3px 11px 3px 16px !important',
    },
}));

export interface TableSumColumsRowPropsType {
    rows: TableRowType[];
    visilbeColumns: TableColumnType[];
    setSelectedRows?: (selectedRows: SelectRowType[]) => void;
    sumCols: SumColumnsType;
    sumColsFilter?: (row: TableRowType) => boolean;
    rowActions?: RowActionPropsType[];
    showClearFilters?: boolean;
}

const TableSumColumsRow: FC<TableSumColumsRowPropsType> = (props) => {
    let sumRows = props.rows;

    if (props.sumColsFilter) {
        // @ts-ignore
        sumRows = props.rows.filter((row) => props.sumColsFilter(row));
    }

    return (
        <MuiTableRowTotal>
            {props.setSelectedRows && <MuiTableCell />}
            {props.visilbeColumns.map((column, index) => {
                let text: string | ReactNode = '';
                if (!index) {
                    text = translate('table.total');
                }
                if (props.sumCols[column.key]) {
                    if (typeof props.sumCols[column.key] === 'function') {
                        // @ts-ignore
                        text = props.sumCols[column.key](sumRows);
                    } else {
                        text = sumArray(sumRows, column.key);
                    }
                    if (column.type === 'number-filter' && isNumericValue(text)) {
                        text = formatNumber(text);
                    }
                }
                return <MuiTableCell key={column.key}>{text}</MuiTableCell>;
            })}
            {props.rowActions || props.showClearFilters ? <MuiTableCell /> : null}
        </MuiTableRowTotal>
    );
};

export default TableSumColumsRow;
